import { render, staticRenderFns } from "./scan-code.vue?vue&type=template&id=0256b620&scoped=true&"
import script from "./scan-code.vue?vue&type=script&lang=js&"
export * from "./scan-code.vue?vue&type=script&lang=js&"
import style0 from "./scan-code.vue?vue&type=style&index=0&id=0256b620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0256b620",
  null
  
)

export default component.exports